"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = addPageMetaDataTracking;
var _upropsCookieData = _interopRequireDefault(require("../../helpers/upropsCookieData"));
var _getCookieConsentData = _interopRequireDefault(require("../../helpers/getCookieConsentData"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var addToDataLayer = function addToDataLayer(data) {
  var _window;
  var dataSource = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var sourceId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var identifiableNewData = data;
  if (dataSource) {
    identifiableNewData.dataSource = dataSource;
  }
  if (sourceId) {
    identifiableNewData.sourceId = sourceId;
  }
  if (typeof window !== 'undefined' && window && (_window = window) !== null && _window !== void 0 && (_window = _window.riDigitalData) !== null && _window !== void 0 && _window.add) {
    window.riDigitalData.add('pageMetaData', identifiableNewData);
  }
};
var getOrientation = function getOrientation() {
  var mediaQueryList = window.matchMedia('(orientation: portrait)');
  if (mediaQueryList.matches) {
    return 'Portrait';
  }
  return 'Landscape';
};
var envMapping = function envMapping(env) {
  switch (env) {
    case 'riverisland':
      return 'Production';
    case 'ripreprod':
      return 'PPE';
    case 'ripostprod':
      return 'PostProd';
    case 'demo':
      return 'Development';
    default:
      return env === null || env === void 0 ? void 0 : env.toUpperCase();
  }
};
function addPageMetaDataTracking() {
  var _window$tcpl, _window$tcpl2, _data$, _data$2, _data$3;
  var pageMetaData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var name = pageMetaData.name,
    contentGroup = pageMetaData.contentGroup,
    type = pageMetaData.type,
    view = pageMetaData.view,
    categories = pageMetaData.categories,
    article = pageMetaData.article,
    productCount = pageMetaData.productCount,
    filter = pageMetaData.filter,
    searchTerm = pageMetaData.searchTerm,
    isUserLoggedIn = pageMetaData.isUserLoggedIn,
    userId = pageMetaData.userId,
    userAge = pageMetaData.userAge,
    userHasTransacted = pageMetaData.userHasTransacted,
    shippingPassStatus = pageMetaData.shippingPassStatus,
    countryCode = pageMetaData.countryCode,
    currencyCode = pageMetaData.currencyCode,
    checkoutAppVersion = pageMetaData.checkoutAppVersion,
    cartAppVersion = pageMetaData.cartAppVersion,
    env = pageMetaData.env,
    envMap = pageMetaData.envMap,
    locale = pageMetaData.locale,
    dataSource = pageMetaData.dataSource,
    _pageMetaData$sourceI = pageMetaData.sourceId,
    sourceId = _pageMetaData$sourceI === void 0 ? null : _pageMetaData$sourceI,
    campaign = pageMetaData.campaign,
    source = pageMetaData.source,
    medium = pageMetaData.medium,
    clusterId = pageMetaData.clusterId;
  var _window2 = window,
    location = _window2.location;
  var hostname = location.hostname,
    href = location.href;
  var _ref = ((_window$tcpl = window.tcpl) === null || _window$tcpl === void 0 || (_window$tcpl = _window$tcpl.datalayer) === null || _window$tcpl === void 0 ? void 0 : _window$tcpl.context) || {},
    language = _ref.language,
    environment = _ref.environment,
    currency = _ref.currency,
    country = _ref.country;
  var _ref2 = ((_window$tcpl2 = window.tcpl) === null || _window$tcpl2 === void 0 ? void 0 : _window$tcpl2.datalayer) || {},
    _ref2$data = _ref2.data,
    data = _ref2$data === void 0 ? [] : _ref2$data;
  var mappedEnv = envMap && envMapping(envMap);
  var metaData = {
    page: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
      fullUrl: href,
      entryUrl: hostname,
      currencyCode: currency || currencyCode,
      country: country || countryCode,
      countryCode: country || countryCode,
      language: (language === null || language === void 0 ? void 0 : language.toLowerCase()) || (locale === null || locale === void 0 ? void 0 : locale.toLowerCase()) || 'en-gb',
      environment: environment || env || mappedEnv || 'production',
      orientation: getOrientation()
    }, checkoutAppVersion && {
      checkoutAppVersion: checkoutAppVersion
    }), cartAppVersion && {
      cartAppVersion: cartAppVersion
    }), name && {
      name: name
    }), contentGroup && {
      contentGroup: contentGroup
    }), campaign && {
      campaign: campaign
    }), source && {
      source: source
    }), medium && {
      medium: medium
    }), {}, {
      clusterId: clusterId
    }),
    user: _objectSpread({
      loggedIn: false,
      hasTransacted: false,
      userAgent: navigator.userAgent,
      cookieConsent: _objectSpread({}, (0, _getCookieConsentData["default"])())
    }, (0, _upropsCookieData["default"])())
  };

  // for checkout, where we do not have uprops cookie
  if (isUserLoggedIn !== undefined) {
    metaData.user = {
      loggedIn: isUserLoggedIn,
      id: userId,
      age: userAge,
      deliveryPassStatus: shippingPassStatus,
      hasTransacted: userHasTransacted,
      userAgent: navigator.userAgent,
      cookieConsent: _objectSpread({}, (0, _getCookieConsentData["default"])())
    };
  }
  if (categories) {
    var _categories = _slicedToArray(categories, 3),
      category1 = _categories[0],
      category2 = _categories[1],
      category3 = _categories[2];
    metaData.page = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, metaData.page), category1 && {
      category1: category1
    }), category2 && {
      category2: category2
    }), category3 && {
      category3: category3
    });
  }
  if (article) {
    metaData.page = _objectSpread(_objectSpread({}, metaData.page), {}, {
      article: _objectSpread({}, article)
    });
  }
  if (productCount) {
    metaData.page = _objectSpread(_objectSpread({}, metaData.page), {}, {
      productCount: productCount
    });
  }
  if (searchTerm || data !== null && data !== void 0 && (_data$ = data[0]) !== null && _data$ !== void 0 && _data$.searchTerm) {
    metaData.page = _objectSpread(_objectSpread({}, metaData.page), {}, {
      searchTerm: searchTerm || data[0].searchTerm
    });
  }
  if (filter) {
    metaData.page = _objectSpread(_objectSpread({}, metaData.page), {}, {
      filter: filter
    });
  }
  if (view || data !== null && data !== void 0 && (_data$2 = data[0]) !== null && _data$2 !== void 0 && _data$2.view) {
    metaData.page = _objectSpread(_objectSpread({}, metaData.page), {}, {
      view: view || data[0].view
    });
  }
  if (type || data !== null && data !== void 0 && (_data$3 = data[0]) !== null && _data$3 !== void 0 && _data$3.type) {
    metaData.page = _objectSpread(_objectSpread({}, metaData.page), {}, {
      type: type || data[0].type
    });
  }
  addToDataLayer(metaData, dataSource, sourceId);
  return metaData;
}